"use client";

import { Header } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const Head = () => {
  const t = useTranslations("team");
  return <Header title={t("head.page")} subtitle={t("head.title")} />;
};

export default Head;
